module.exports = __webpack_public_path__ + "static/media/route-board-purple.ffdccf07.svg";